export const subscriberAdminStrings = {
    loading: 'Loading subscribers...',
    signedOut: 'Sign in to manage subscribers.',
    loginFailed: 'The username or password is incorrect.',
    requestFailed: 'The request could not be completed.',
    noSubscribers: 'No subscribers match the current filters.',
    addSubscriber: 'Add subscriber',
    editSubscriber: 'Edit subscriber',
    addSucceeded: 'Subscriber added.',
    updateSucceeded: 'Subscriber updated.',
    confirmSucceeded: 'Email address confirmed.',
    deleteSucceeded: 'Subscriber deleted.',
    confirmEmail: (emailAddress: string) => `Confirm ${emailAddress}`,
    editEmail: (emailAddress: string) => `Edit ${emailAddress}`,
    deleteEmail: (emailAddress: string) => `Delete ${emailAddress}`,
    confirmDelete: (emailAddress: string) => `Delete subscriber “${emailAddress}”? This cannot be undone.`,
    pageSummary: (page: number, totalPages: number, totalCount: number) =>
        totalCount === 0 ? 'No results' : `Page ${page} of ${totalPages} · ${totalCount} subscriber${totalCount === 1 ? '' : 's'}`
} as const;
